var r = /* @__PURE__ */ ((o) => (o[o.NoSeason = 0] = "NoSeason", o[o.Season2 = 1] = "Season2", o[o.Season2_Ronin = 2] = "Season2_Ronin", o))(r || {});
export {
  r as SeasonMintType
};
//# sourceMappingURL=season.js.map
